
import { FileData, ResultData } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { DbInuseResult, TCMRunProcess, TCMSchedule, TCMScheduleSearch, TCMScheduleService, TCMStatsItem } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";
import { randomColor } from "../../../../common";

export interface TCMScheduleOptions extends ControllerOptions<TCMSchedule> {
    responseId?: string;
    comment?: string;
    statusId?: string;
    mine?: boolean;
}

export const initTCMSchedule = () => {
    let item: TCMSchedule = {
        name: "",
        createdBy: "",
        color: randomColor(),
        rankingCalculationPoints: 0,
        rankingCalculationPrice: 0
    }
    return item;
}


export class ClientTCMScheduleService extends BaseClientService implements DataController<TCMSchedule> {

    private _service: TCMScheduleService;


    constructor() {
        super();
        this._service = new TCMScheduleService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: TCMScheduleOptions): Promise<ResultData<TCMSchedule>> {
        let search: TCMScheduleSearch  = {
            filter: options.filter ?? "",
            status: options.statusId ?? "",
            response: options.responseId ?? "",
            mine: options.mine ?? false
        }

        return await this._service.get(this.buildFetchParams(options), this.token, search);

    }

    public async stats(options: TCMScheduleOptions): Promise<TCMStatsItem[]> {
        if (options.id) {
            return await this._service.stats(this.token, options.id);
        }
        return []

    }
    public async getLookup(options: TCMScheduleOptions): Promise<ResultData<TCMSchedule>> {
        let search: TCMScheduleSearch  = {
            filter: options.filter ?? "",
            status: options.statusId ?? "",
            response: options.responseId ?? "",
            mine: options.mine ?? false
        }

        
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, search);
        return data;
    }

    public async getById(options: TCMScheduleOptions): Promise<TCMSchedule | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMScheduleOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMScheduleOptions): Promise<TCMSchedule | TCMSchedule[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMScheduleOptions): Promise<TCMSchedule | TCMSchedule[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async validateTenderNumber(number: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateNumber(number, this.token, id)
    }

    public async import(options: TCMScheduleOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMScheduleOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

    public async template(options: TCMScheduleOptions): Promise<FileData | undefined> {
        if (options.id)
            return await this._service.template(options.id, this.token, options.comment);
    }

    public async validateGoals(scheduleId: string): Promise<TCMRunProcess> {

        return await this._service.validateGoals(this.token, scheduleId);
    }

    public async clone(options: TCMScheduleOptions): Promise<TCMSchedule[] | TCMSchedule | null> {
        let item = options.item;
        let scheduleId = options.id;
        if (item && scheduleId) {
            return await this._service.clone(scheduleId, item, this.token);
        }
        return null;
    }

    public async inUse(options: TCMScheduleOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        } else {
            throw new Error("ID is required for inUse check");
        }
    }

    public async syncSheets(options: TCMScheduleOptions): Promise<TCMSchedule | null> {
        if (options.id) {
            return await this._service.syncSheets(this.token, options.id);
        } else {
            throw new Error("ID is required for sheet sync");
        }
    }


}